<template>
  <div>
    <!-- header -->
    <Header></Header>

    <!-- Banner -->
    <SubBanner></SubBanner>

    <article class="recruit-wrapper">
      <div class="container">
        <ul class="tab-list">
          <li><a href="#">Recruit</a></li>
          <li><a href="#qna">FAQ</a></li>
        </ul>
      </div>

      <Con1></Con1>
      <Con2></Con2>
      <Con3></Con3>
      <Con4></Con4>
      <Con5></Con5>
    </article>

    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import { onMounted } from "vue";
import Header from "@/components/NewGlobal/Introduce/Header.vue";
import SubBanner from "@/components/NewGlobal/Introduce/SubBanner.vue";
import Con1 from "@/components/NewGlobal/Introduce/Recruit/Con1.vue";
import Con2 from "@/components/NewGlobal/Introduce/Recruit/Con2.vue";
import Con3 from "@/components/NewGlobal/Introduce/Recruit/Con3.vue";
import Con4 from "@/components/NewGlobal/Introduce/Recruit/Con4.vue";
import Con5 from "@/components/NewGlobal/Introduce/Recruit/Con5.vue";
import Footer from "@/components/NewGlobal/Footer.vue";
import "@/assets/style/newGlobalReset.scss";

export default {
  name: "Recruit",
  components: {
    Header,
    SubBanner,
    Con1,
    Con2,
    Con3,
    Con4,
    Con5,
    Footer,
  },
  setup() {
    onMounted(() => {
      // const header = document.getElementById("header");
      // header.style.display = "none";
    });
  },
};
</script>

<style lang="scss" scoped>
.recruit-wrapper {
  .title {
    font-size: 45px;
    font-weight: 700;
    text-align: center;
    padding: 50px 0;
  }

  .tab-list {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 50px;
    padding: 40px 0;

    @media screen and (min-width: 1350px) {
      padding: 80px 0;
    }

    li {
      font-size: 20px;
      font-weight: 700;
      text-decoration: underline;
      cursor: pointer;
    }
  }
}
</style>
